<template>
  <div class="date-container">
    <FriedH5 class="gray-text">{{ month }}</FriedH5>
    <FriedH3>{{ day }}</FriedH3>
    <FriedH5 v-if="year" class="gray-text">{{ year }}</FriedH5>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import { DateTime } from 'luxon';
import { DateHelper } from '@getaccept/lib-shared/src/helpers/date.helper';

export default defineComponent({
  props: {
    date: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const date = computed(() => DateTime.fromMillis(props.date));

    const day = computed(() => date.value.day);
    const month = computed(() => date.value.toLocaleString({ month: 'short' }));
    const year = computed(() => (DateHelper.isSameYear(date.value) ? '' : date.value.year));

    return {
      day,
      month,
      year,
    };
  },
});
</script>

<style lang="scss" scoped>
.date-container {
  padding: var(--spacing-50);
  border-radius: var(--radius-medium);
  text-align: center;
  background-color: var(--gray-98);
  width: 48px;

  .gray-text {
    color: var(--text-gray);
  }
}
</style>
